import { connect } from 'react-redux';
import { channelLayoutValues } from 'widget/player-widget';
import ui from 'redux-ui';

import getQueryParams from 'shared/utils/get-query-params';
import { videosPerPage } from 'widget/utils/videos-sizes';
import BIUnhandledErrorLogger from 'shared/bi/bi-unhandled-error-logger';

import SEARCH_QUERY_FIELDS from 'shared/constants/search-query-fields';

import { getChannelForWidget } from 'shared/selectors/channels';
import { getNumberOfRows } from 'shared/selectors/app-settings';

import TooltipPopout from 'shared/components/tooltip/tooltip-popout';
import Modal from 'shared/components/modal/modal';

import ExperimentsLoader from 'shared/data-components/experiments';
import AppSettingsLoader from 'widget/data-components/app-settings';
import UpdateChannelPublishedState from 'widget/data-components/update-channel-published-state';
import ChannelLoader from 'widget/data-components/channel';
import PaymentInfoLoader from 'widget/data-components/payment-info';
import ChannelVideoLoader from 'widget/data-components/channel-video';
import PaginatedChannelVideosLoader, { DATA_KEY as PAGINATED_VIDEOS_KEY } from 'widget/data-components/paginated-channel-videos';
import NextChannelVideosLoader from 'widget/data-components/next-channel-videos';
import CurrentSiteUser from 'widget/data-components/current-site-user';
import ReloadChannelPaymentDataOnPayment from 'widget/data-components/reload-channel-payment-data-on-payment';
import ClearVideoUrlsCacheOnPayment from 'widget/data-components/clear-video-urls-cache-on-payment';
import PaymentEventProxy from 'shared/components/payment-events/proxy';


import 'shared/styles/core.styl';


@connect(state => ({
  appSettings: state.appSettings,
  selectedVideoId: state.selectedVideoId,
  channelData: getChannelForWidget(state),
  currentChannelId: state.currentChannelId,
  firstVideoId: _.get(state.lazyVideoLists[PAGINATED_VIDEOS_KEY], 'idChunks[0][0]'),
  numberOfRows: getNumberOfRows(state),
}))
@ui({
  state: {
    searchQuery: '',
    searchQueryField: SEARCH_QUERY_FIELDS.QUERY,
  },
})
export default class DesktopLayout extends React.Component {

  static propTypes = {
    selectedVideoId: React.PropTypes.string,
    children: React.PropTypes.element,
    currentChannelId: React.PropTypes.string,
    firstVideoId: React.PropTypes.string,
    channelData: React.PropTypes.object,
    appSettings: React.PropTypes.object,
    ui: React.PropTypes.object,
    numberOfRows: React.PropTypes.number,
  };

  // Todo: move to loader or reducer
  get videosPerPage() {
    const { appSettings, numberOfRows, channelData } = this.props;
    const videosInRow = appSettings.numbers.videosInRow;
    if (appSettings.numbers.channelLayout === channelLayoutValues.STRIP) {
      return videosInRow * numberOfRows;
    }

    const allVideosCount = channelData && channelData.videosCount;

    return videosPerPage(
      appSettings.requestedWidgetSize,
      videosInRow,
      allVideosCount,
      appSettings,
      channelData || {}
    );
  }

  get content() {
    const {
      children, appSettings, firstVideoId, currentChannelId, channelData, selectedVideoId,
      ui: { searchQuery, searchQueryField },
    } = this.props;

    if (!appSettings || !currentChannelId) {
      return null;
    }

    const { compId, siteUrl } = appSettings;
    const featuredItemId = channelData && channelData.featuredItem;
    const queryParams = getQueryParams(siteUrl);

    let videoIdFromUrl = null;
    if (compId === queryParams['wix-vod-comp-id']) {
      videoIdFromUrl = queryParams['wix-vod-video-id'];
    }

    const nextChannelVideosVideoId = selectedVideoId || videoIdFromUrl || featuredItemId || firstVideoId;

    return (
      <ChannelLoader channelId={currentChannelId}>
        <PaginatedChannelVideosLoader channelId={currentChannelId}
                                      videosPerUIPage={this.videosPerPage}
                                      searchQuery={searchQuery}
                                      searchQueryField={searchQueryField}
                                      as={PAGINATED_VIDEOS_KEY}>
          <ChannelVideoLoader channelId={currentChannelId}
                              videoId={videoIdFromUrl}>
            <NextChannelVideosLoader channelId={currentChannelId}
                                     currentVideoId={nextChannelVideosVideoId}>
              <CurrentSiteUser>
                <PaymentInfoLoader channelId={currentChannelId}>
                  {children}
                  <PaymentEventProxy />
                  <ReloadChannelPaymentDataOnPayment />
                  <ClearVideoUrlsCacheOnPayment />
                </PaymentInfoLoader>
              </CurrentSiteUser>
            </NextChannelVideosLoader>
          </ChannelVideoLoader>
        </PaginatedChannelVideosLoader>
      </ChannelLoader>
    );
  }

  render() {
    const { currentChannelId, appSettings } = this.props;

    return (
      <div>
        <ExperimentsLoader>
          <BIUnhandledErrorLogger />
          <AppSettingsLoader />
          <UpdateChannelPublishedState channelId={currentChannelId} />
          {this.content}

          <Modal settings={appSettings} />
          <TooltipPopout />
        </ExperimentsLoader>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/layouts/desktop/desktop.js